module.exports = __webpack_public_path__ + "static/media/money-bill-alt.89a87298.svg";